/**
 * Constants for paywall experiment components
 * Centralizes all magic numbers, colors, and repeated values
 */

// Colors
export const COLORS = {
  // teal-100 from Tailwind theme (default app background)
  lightBackground: "#f1f9fc",
  // teal-1000 from Tailwind theme
  background: "#001e2b",
  teal600: "rgb(14,165,165)",
  white: "#ffffff",
  slate50: "#f8fafc",
  purple700: "#a841ba",
  borderDefault: "rgba(255,255,255,0.15)",
  borderSelected: "rgb(14,165,165)",
} as const;

// Z-index values
export const Z_INDEX = {
  background: -10,
  illustration: 0,
  content: 10,
  closeButton: 9999,
} as const;

// Sizes
export const SIZES = {
  closeButton: 24,
  checkIcon: 22,
  checkmarkCircle: 30,
  checkmarkInner: 18.75,
  logoHeight: 32,
  illustration: {
    width: 188,
    height: 188,
  },
} as const;

// Animation
export const ANIMATION = {
  fadeInOut: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 },
    transition: { duration: 0.3, ease: "easeOut" },
  },
  contentFade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] },
  },
} as const;

// Analytics event names
export const ANALYTICS_EVENTS = {
  paywallDismissed: "paywall_dismissed",
  paywallStartFreeTrial: "paywall_start_free_trial",
  twoProductContinue: "paywall_two_product_continue",
} as const;

// Gradient configurations
export const GRADIENTS = {
  unlimitedRx: {
    height: "248.148px",
    width: "224.817px",
    topOffset: "-60.148px",
  },
  pediatricSupport: {
    height: "203.586px",
    width: "224.817px",
    topOffset: "-15.586px",
  },
} as const;

// Miscellaneous
export const MISC = {
  experimentName: "novpaywall2products",
  hiddenValue: "hidden",
} as const;
